import { Post } from "services/apiService";
import {
  PO_SEARCH_OPPORTUNITIES_REQUEST,
  PO_SEARCH_OPPORTUNITIES_SUCCESS,
  PO_SEARCH_OPPORTUNITIES_ERROR,
} from "./action-type";
import {
  BASE_URL,
  SEARCH_ORDEROPPORTUNITIES_ENDPOINT,
  SOMS_API_KEY,
} from "services/CONSTANTS";

export const poSearchOpportunities = (params) => async (dispatch) => {
  const apiUrl = `${BASE_URL}${SEARCH_ORDEROPPORTUNITIES_ENDPOINT}?apikey=${SOMS_API_KEY}`;
  dispatch({ type: PO_SEARCH_OPPORTUNITIES_REQUEST });

  Post({
    url: apiUrl,
    params: params,
    config: {},
  })
    .then((response) => {
      if (response.status === 200) {
        dispatch({
          type: PO_SEARCH_OPPORTUNITIES_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: PO_SEARCH_OPPORTUNITIES_ERROR,
          payload: response,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: PO_SEARCH_OPPORTUNITIES_ERROR,
        payload: err,
      });
    });
};
